import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const pairs = [{
  problem: 'Cuando estás saturado',
  tool: 'Mindfulness',
  color: 'rose' as const
}, {
  problem: 'Cuando tenés que hablar',
  tool: 'Conversaciones Difíciles',
  color: 'gold' as const
}, {
  problem: 'Cuando no sabés qué decir',
  tool: '100 Respuestas',
  color: 'rose' as const
}, {
  problem: 'Cuando el problema es la dinámica del equipo',
  tool: 'Ejercicios para Mejorar el Ambiente Laboral',
  color: 'gold' as const
}];
export function ProblemToolMap() {
  return <section className="w-full py-20 md:py-28 px-4" data-id="element-234" data-mp="3d26up0omgvfl">
      <div className="max-w-5xl mx-auto" data-id="element-235" data-mp="3hzq8y0lbl87j">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-236" data-mp="3hynks0fdtjvb">
          <h2 className="font-serif font-bold text-3xl sm:text-4xl md:text-5xl text-ink leading-[1.1] uppercase tracking-tight" data-id="element-237" data-mp="2rnb7fpddcemv">
            4 problemas.{' '}
            <span className="font-serif-italic text-rose font-normal normal-case" data-id="element-238" data-mp="2morlvq2ot4v1">
              4 herramientas.
            </span>
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-239" data-mp="3fd5iq2i1hv50">
          {pairs.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="grid sm:grid-cols-[1fr_auto_1fr] items-center gap-3 sm:gap-5 bg-white border border-line rounded-2xl p-5 md:p-6 shadow-sm" data-id="element-240" data-mp="3adstjb3p4bz9" data-mpi={i}>
              <span className="text-ink font-semibold text-sm md:text-base uppercase tracking-tight" data-id="element-241" data-mp="1rd1tnk2mda5m">
                {p.problem}
              </span>
              <span className={`hidden sm:flex w-9 h-9 rounded-full items-center justify-center ${p.color === 'rose' ? 'bg-rose/15' : 'bg-gold/15'}`} data-id="element-242" data-mp="1idenkkyy3g68">
                <ArrowRightIcon className={`w-4 h-4 ${p.color === 'rose' ? 'text-rose' : 'text-gold'}`} data-id="element-243" data-mp="18o4tx0ogdpg0" />
              </span>
              <span className={`font-serif-italic text-lg md:text-xl ${p.color === 'rose' ? 'text-rose' : 'text-gold'}`} data-id="element-244" data-mp="1dhg6lify50fu">
                {p.tool}
              </span>
            </motion.div>)}
        </div>

        <p className="text-center font-serif font-bold text-xl md:text-2xl text-ink uppercase tracking-tight mt-10" data-id="element-245" data-mp="ppiurrchy8eq">
          Un solo kit para tu día laboral real.
        </p>
      </div>
    </section>;
}